import React, { useState, useEffect } from "react";
import { Card, Form } from "tabler-react";
import MonthReport from "./components/MonthReport";

//hooks
import useQueryURL from "../../../../hooks/services/useQueryURL";
import useUsers from "../../../../hooks/api/Users/useUsers";

const SummaryReport = () => {
  // const [year, setYear] = useState("2021");
  const { getQuery } = useQueryURL();

  let DR_month = getQuery("month");
  let DR_year = getQuery("year");

  const [month, setMonth] = useState(DR_month ? DR_month : "All");
  const [year, setYear] = useState(DR_year ? DR_year : "2021");

  let months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const { user } = useUsers();

  const [accessLevel, setAccessLevel] = useState("none");

  useEffect(() => {
    setAccessLevel(
      user.length != 0
        ? user.apps_list.find((user) => user.app === "lazada-shop").access
        : ""
    );
  }, [user]);

  useEffect(() => {
    if (user.length != 0 && accessLevel === "none") {
      window.location.replace("/");
    }
  }, [user, accessLevel]);

  return (
    <>
      <Card>
        <Card.Header>
          Lazada Summary Report
          <Card.Options>
            <Form.Select
              value={month}
              onChange={(e) =>
                window.location.replace(
                  `/LazadaShop/Report/SummaryReport?month=${e.target.value}&year=${year}`
                )
              }
            >
              <option value="All">SELECT ALL</option>
              {months.map((m, index) => (
                <option value={m} key={index}>
                  {m}
                </option>
              ))}
            </Form.Select>
            <Form.Select
              value={year}
              onChange={(e) =>
                window.location.replace(
                  `/LazadaShop/Report/SummaryReport?month=${month}&year=${e.target.value}`
                )
              }
            >
              <option value="">SELECT YEAR</option>
              <option value="2021">2021</option>
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
            </Form.Select>
          </Card.Options>
        </Card.Header>
        {month !== "All" ? (
          <MonthReport data={{ month: `${month}-report`, year }} />
        ) : (
          <>
            {months.map((m, index) => (
              <React.Fragment key={index}>
                <MonthReport data={{ month: `${m}-report`, year }} />
              </React.Fragment>
            ))}
          </>
        )}
      </Card>
    </>
  );
};

export default SummaryReport;
